const versionCategoryOptions = [
  {
    value: "",
    label: "None",
    disabled: false,
  },
  {
    value: "Full Support",
    label: "Full Support",
    disabled: false,
  },
  {
    value: "Maintenance Support",
    label: "Maintenance Support",
    disabled: false,
  },
  {
    value: "Extended Support",
    label: "Extended Support",
    disabled: false,
  },
  {
    value: "End of Maintenance",
    label: "End of Maintenance",
    disabled: false,
  },
  {
    value: "End of life",
    label: "End of life",
    disabled: false,
  },
];

const versionColorStyles = {
  "Full Support": {
    //backgroundColor: '#D4F4B4'
    borderLeftStyle: "solid",
    borderLeftWidth: "thick",
    borderLeftColor: "#ADE12D",
  },
  "Maintenance Support": {
    //backgroundColor: '#FEF8C6'
    borderLeftStyle: "solid",
    borderLeftWidth: "thick",
    borderLeftColor: "#c1ce16",
  },
  "Extended Support": {
    //backgroundColor: '#FDB3AB'
    borderLeftStyle: "solid",
    borderLeftWidth: "thick",
    borderLeftColor: "#F4C145",
  },
  "End of life": {
    //backgroundColor: '#FDB3AB'
    borderLeftStyle: "solid",
    borderLeftWidth: "thick",
    borderLeftColor: "#C9180A",
  },
  preview: {
    //backgroundColor: '#FED1A0'
    borderLeftStyle: "solid",
    borderLeftWidth: "thick",
    borderLeftColor: "#FED1A0",
  },
  future: {
    //backgroundColor: '#C1E6F5'
    borderLeftStyle: "solid",
    borderLeftWidth: "thick",
    borderLeftColor: "#C1E6F5",
  },
};

const versionCategoryStyles = {
  borderBottomStyle: "solid",
  borderBottomWidth: "3px",
  borderBottomColor: "#8bc1f7",
};

const categoryRows = {
  "Full Support": "<div><strong>Full Support</strong></div>",
  "Maintenance Support": "<div><strong>Maintenance Support</strong></div>",
  "Extended Support": "<div><strong>Extended Support</strong></div>",
  "End of Maintenance": "<div><strong>End of Maintenance</strong></div>",
  "End of life": "<div><strong>End of life</strong></div>",
  Uncategorized: "<div><strong>Uncategorized</strong></div>",
};

const versionCategoryConst = {
  versionCategoryOptions,
  versionColorStyles,
  versionCategoryStyles,
  categoryRows,
};

export default versionCategoryConst;
